import React from 'react';
import styled from '@emotion/styled';

const KioskCard = ({ className, value, label, icon, icon_dark, darkMode }) => (
  <KioskCardDiv>
    <div className={`${className} stat-card`}>
      <img src={darkMode ? icon_dark : icon} alt={`${className} icon`} />
      <div className="stats">
        <p className="value">{value}</p>
        <p className="label">{label}</p>
      </div>
    </div>
  </KioskCardDiv>
);

const KioskCardDiv = styled.div`
  .stat-card {
    align-items: center;
    column-gap: 12px;
    display: flex;
    justify-content: flex-start;
    padding: 14px;
    width: 340px;

    img {
      min-width: 75px;
      width: 4vw;
    }
  }
`;

export default KioskCard;
